import React, { Component } from 'react'
import { AlphanumericInputWithMask } from '@lmig/lmds-react'

class Address2 extends Component {
  render() {
    const { onChangeValue } = this.props
    const regex = /^[^*|":<>[\]{}`\\;@$%!]+$/
    return (
      <AlphanumericInputWithMask
        name='address2'
        id='Alphanumeric--address2'
        labelVisual='Address 2'
        labelA11y='Address 2'
        mask={{mask: regex}}
        onChange={onChangeValue}
      />
    )
  }
}

export default Address2
